import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Truck, Fuel } from 'lucide-react';

export const ReportMenu: React.FC = () => {
  const { t } = useTranslation();

  const reportTypes = [
    {
      path: '/reports/vehicle-profitability',
      titleKey: 'reports.vehicleProfitability',
      descriptionKey: 'reports.vehicleProfitabilityDesc',
      icon: Truck,
      color: 'bg-green-500',
    },
    {
      path: '/reports/fuel-efficiency',
      titleKey: 'reports.fuelEfficiency',
      descriptionKey: 'reports.fuelEfficiencyDesc',
      icon: Fuel,
      color: 'bg-purple-500',
    },
  ];

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">{t('reports.title')}</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reportTypes.map((report) => (
          <Link
            key={report.path}
            to={report.path}
            className="card hover:shadow-md transition-shadow"
          >
            <div className="flex items-start space-x-4">
              <div className={`${report.color} p-3 rounded-lg`}>
                <report.icon className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="font-semibold text-gray-800">{t(report.titleKey)}</h3>
                <p className="text-sm text-gray-500 mt-1">{t(report.descriptionKey, { defaultValue: '' })}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};
